import { render, staticRenderFns } from "./ProdutoTable.vue?vue&type=template&id=527e4611"
import script from "./ProdutoTable.vue?vue&type=script&lang=js"
export * from "./ProdutoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports